import { CalendarCheck } from "lucide-react";
import { trackEvent } from "@/lib/api";
import { Card, btnPrimary } from "@/components/portal/ui";

const validLink = (u) => typeof u === "string" && /^https?:\/\//i.test(u.trim());

// Included, optional one-time review-call button. Rendered by the deliverable view only after the
// matching report/Blueprint is published; renders nothing unless a valid booking link is provided
// (never a placeholder/broken link).
export function ReviewCallCard({ product, link, label, body, eventName, testid }) {
  if (!validLink(link)) return null;
  return (
    <Card className="p-6 mt-6" data-testid={testid}>
      <div className="flex items-start gap-3">
        <div className="shrink-0 w-10 h-10 rounded-full bg-[#667A66]/12 grid place-items-center text-[#4d6b4d]">
          <CalendarCheck size={18} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="eyebrow text-[#4d6b4d] mb-1">Included · Optional</div>
          <p className="text-[#6B665E] text-sm">{body}</p>
          <a href={link.trim()} target="_blank" rel="noopener noreferrer"
            onClick={() => trackEvent(eventName, { product })}
            data-testid={`${testid}-btn`} className={`${btnPrimary} mt-4 inline-flex items-center gap-2`}>
            <CalendarCheck size={16} /> {label}
          </a>
        </div>
      </div>
    </Card>
  );
}
